import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

import Auth from '../../AuthContainer';
import history from '../../../history';

import './Unauthenticated.css';

class Unauthenticated extends Component {

    constructor(props){
        super(props)
        this.state = {
            allowUserAuth: false
        }
    }

    componentWillMount() {}


    componentWillReceiveProps(newProps) {
    }

    render() {
        return (
            <section className="hsg-unauthenticated-container">
                {this.props.children}
                {/* <div style={{paddingTop: Math.floor(window.innerHeight / 2)}}><Loader /></div> */}
            </section>
        );
    }

}


export default Unauthenticated